export default [{
  path: 'd-fin/gefin-relatorios/fluxo-caixa',
  name: 'fluxo-caixa',
  component: () => import('./index'),
  meta: {
    visible: true,
    title: 'Fluxo de Caixa',
    order: '1',
    breadcrumb: [
      { name: 'Home', link: 'home' },
      { name: 'D-FIN', link: 'd-fin' },
      { name: 'Relatorios', link: 'gefin-relatorios' },
      { name: 'Fluxo de caixa' }
    ]
  }
}]
